/* eslint-disable no-empty-pattern */
import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import {
  Toolbar,
  AppBar,
  Typography,
  Box,
  Stack,
  Avatar,
} from '@mui/material/';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/system';
import { tokens } from '../../../tokens';
// import ReportDialog from '../../accountdetails/reportcryptocrime/ReportDialog';
import AppMenu from '../../homepage/app-menu/AppMenu';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import MonetizationButton from '../../layouts/searchlayout/utils/MonetizationButton';
import ModelTabs from './ModelTabs';


function ColorText({ children }) {
  return <span style={{ color: tokens.palette_secondary }}>{children}</span>;
}



const BlockTypo = styled(Typography)(() => ({
  fontFamily: 'play',
  opacity: 1,
  fontSize: '1.50rem',
  fontWeight: 700,
  lineHeight: '1.5rem',
  textAlign: 'center',
  paddingLeft: 0,
  whiteSpace: 'wrap',
  color: tokens.palette_secondary,
  cursor: 'pointer',
}));

const TitleTypo = styled(Typography)(() => ({
  textTransform: 'none',
  // fontFamily: 'Roboto,arial,sans-serif',
  fontFamily: 'play',
  opacity: 1,
  display: 'inline-block',
  fontStretch: '100%',
  fontSize: '1.50rem',
  fontWeight: 500,
  textSizeAdjust: '100%',
  cursor: 'pointer',
  lineHeight: '1.75rem',
  letterSpacing: 'normal',
  textAlign: 'left',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  marginLeft: '4px',
  color: tokens.palette_primary,
}));

const StyledToolbar = styled(Toolbar)(() => ({
  alignItems: 'flex-start',
  paddingTop: '16px',
  paddingBottom: '4px',
  paddingRight: '16px',
  paddingLeft: '8px',
  // Override media queries injected by theme.mixins.toolbar
  '@media all': {
    minHeight: 70,
  },
}));

export default function ChatHeader({}) {
  // console.log('Inside ChatHeader.js', setSelectedAPIRoute);
  const router = useRouter();

  const handleClick = () => {
    console.log('MonetizationButton clicked');
    // add other functionality
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          position: 'relative',
          //   borderBottom: (t) => `1px solid ${t.palette.divider}`,
          borderBottom: `1px solid ${tokens.token_search_border_grey}`,
          backgroundColor: {
            xs: tokens.token_surface,
            sm: tokens.token_surface,
            md: tokens.token_surface,
          },
        }}
      >
        <StyledToolbar variant="dense">
          <Link href="/" sx={{}}>
            <Avatar
              variant="rounded"
              sx={{
                bgcolor: 'transparent',
                display: { xs: 'block', sm: 'block', md: 'none' },
                // border: '1px solid',
                // borderColor: tokens.token_grey_300,
                width: '28px',
                height: '28px',
                marginRight: '4px',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <ArrowBackIosOutlinedIcon
                sx={{
                  color: tokens.token_text_grey_on_white,
                  // width: '26px',
                  // height: '26px',
                  fontSize: '1.50rem',
                  paddingTop: '0.25rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // paddingTop: '2px'
                }}
              />
            </Avatar>
          </Link>
          <Link href="/" sx={{}}>
            <Avatar
              variant="rounded"
              sx={{
                bgcolor: 'transparent',
                border: '1px solid',
                borderColor: tokens.token_grey_300,
                width: '28px',
                height: '28px',
              }}
            >
              <BlockTypo>b</BlockTypo>
            </Avatar>
          </Link>
          <TitleTypo sx={{}}>chat</TitleTypo>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ minWidth: '60px' }}>
            <AppMenu />
          </Box>
          <Box sx={{ minWidth: '60px' }}>
            <MonetizationButton router={router} onClick={handleClick} />
          </Box>
        </StyledToolbar>
        <Toolbar variant="dense">
          <Box flexGrow={1} />
          <ModelTabs />
          <Box flexGrow={1} />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
